<template>
  <div
    ref="filter"
    id="filter"
    class="modal modal-right fade modal-more-filters"
    tabindex="-1"
    role="dialog"
    aria-labelledby="filter"
  >
    <div
      class="modal-dialog"
      role="document"
      style="width: 360px;"
    >
      <div
        class="modal-content"
        ref="section"
      >
        <div class="modal-header bg-dark">
          <h6 class="modal-title">
            {{ $t("More Filters") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 pb-5 px-0">
          <div
            class="card card-collapsed border-0 shadow-none mb-0"
          >
            <div class="card-header header-elements-inline border-0 shadow-none p-0">
              <div
                @click="toggleOption('payment_status')"
                name="payment_status"
                aria-expanded="false"
                class="font-weight-semibold cursor-pointer collapsed w-100 d-flex justify-content-between py-2 px-3"
                data-toggle="collapse"
                data-target="#collapse-payment_status"
              >
                <div>{{ $t("Payment Status") }}</div>
                <div class="header-elements">
                  <div class="list-icons">
                    <a
                      :class="['list-icons-item', {'rotate-180': options.payment_status}]"
                      data-action="collapse"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="collapse ui-filter-list card-body  px-4"
              id="collapse-payment_status"
            >
              <div class="filter-option">
                <div
                  class="form-group"
                  :class="{'mb-0': !datainfo.payment_status.length}"
                >
                  <div 
                    v-for="Payment in datainfo.payment_status"
                    :key="Payment.id"
                  >
                    <div
                      :class="['form-check', Payment.disabledStatusId.includes(true) ? 'disabled':'']"
                    >
                      <label 
                        class="form-check-label"
                      >
                        <div 
                          :class="['uniform-choice', Payment.disabledStatusId.includes(true) ? 'disabled':'']"
                        >
                          <span :class="[(dataFilter.payment_status.includes(Payment.id) ? 'checked' : '')]">
                            <input
                              type="radio"
                              class="custom-control-input"
                              :value="Payment.id"
                              :id="'pay-'+Payment.id"
                              v-model="dataFilter.payment_status"
                              @change="filterChange()"
                              :disabled="Payment.disabledStatusId.includes(true)"
                            >
                          </span>
                        </div>
                        {{ Payment.name }}
                      </label>
                    </div>
                  </div>
                </div>
                <div class="clear">
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="clearFilter('payment_status')"
                  >{{ $t("Clear") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="modal-footer fixed-bottom bg-light border-top d-flex justify-content-between py-2 px-3">
          <button
            type="button"
            class="btn btn-light"
            @click="clearFilter('all')"
          >
            {{ $t('Clear all filters') }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="doneFilter()"
            data-dismiss="modal"
          >
            {{ $t('Done') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import Api from '@/services/endpoint/tenant.service'
import DateRangePicker from 'vue2-daterange-picker'
import moment from "moment";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import Axios from 'axios';
import Select2 from "v-select2-component";
import { convertTimezone } from "@/common/tenancy/convertTimezone";

export default {
    name: "FilterMore",
    components: {
        // DateRangePicker,
        // moment,
        // Select2,
        // VueSimpleSuggest
    },
    // props: [
    //     "carrierList",
    //     "statusList",
    // ],
    props: {
        filter: {
            type: [Object, Array],
            default: undefined
        },
        paymentStatus: {
            type: [Object, Array, String, Number],
            default: undefined
        },
    },
    data() {
        let vm = this;
        return {
            options: {
                type: false,
                status: false,
                sales: false,
                payment_status: false,
            },
            dataFilter: initialFilter(),
            datainfo: {
                payment_method: [],
                payment_status: [
                    {
                        'id': 'waiting',
                        'name': this.$t('Pending'),
                        'activeTab': ['all', 'pending', 'processing', 'canceled'],
                        'disabledStatusId': ['completed', 'canceled'],
                    },
                    {
                        'id': 'confirmed',
                        'name': this.$t('Confirmed'),
                        'activeTab': ['all', 'pending', 'canceled'],
                        'disabledStatusId': ['processing', 'completed', 'canceled'],
                    },
                    {
                        'id': 'rejected',
                        'name': this.$t('Rejected'),
                        'activeTab': ['all', 'pending', 'canceled'],
                        'disabledStatusId': ['processing', 'completed', 'canceled'],
                    },
                    {
                        'id': 'canceled',
                        'name': this.$t('Canceled'),
                        'activeTab': ['all', 'returned', 'canceled'],
                        'disabledStatusId': ['pending', 'processing', 'completed'],
                    },
                ],
            },
            params: {
                q: null,
                roles: [],
                per_page: 500,
                left_store: true,
            },
            option: [],
            autoCompleteStyle: {
                vueSimpleSuggest: "position-relative",
                inputWrapper: "",
                defaultInput: "form-control",
                suggestions: "position-absolute list-group z-1000",
                suggestItem: "list-group-item",
            },
            suggestList: [],
        }
    },
    async mounted() {
        $(this.$refs.filter).on('shown.bs.modal', () => {
        });
    },
    computed: {
    },
    methods: {
        onAutocompleteButtonClick(suggestion) {
            this.dataFilter.sales = suggestion.id;
            this.$refs.suggestSaleStaff.autocompleteText(suggestion);
        },
        convertTimezone(date){
            return convertTimezone.utcToLocal(date);
        },
        search() {
            this.getSaleStaff();
        },
        async getSaleStaff(e) {
            let self = this;
            self.params.q = e;
            let queryString = "";
            if (self.params) {
                queryString += "?" + $.param(self.params);
            }
            queryString += "&isSearchName=true&getAllUser=true";
            let response = await Api.Setting.getUser(queryString);
            let res = response.data.data;
            var users = [];
            if (res.length == 0) {
              self.suggestList = users;
              self.$refs.suggestSaleStaff.suggestions = users;
            } else {
              res.forEach(function (element, i) {
                  users.push({
                      'id' : element.id,
                      'title' : element.first_name,
                      'deleted_at' : element.deleted_at,
                      'left_at' : element.left_at,
                  });
                  if ((res.length - 1) == i) {
                    self.suggestList = users;
                    self.$refs.suggestSaleStaff.suggestions = users;
                  }
              });
            }
        },
        toggleOption(key) {
            if (key == 'typeOrder') {
                (this.options.typeOrder) ? this.options.typeOrder = false: this.options.typeOrder = true;
            } else if (key == 'statusOrder') {
                (this.options.status) ? this.options.status = false: this.options.status = true;
            } else if (key == 'sales') {
                (this.options.sales) ? this.options.sales = false: this.options.sales = true;
            }else if (key == 'payment_status') {
                (this.options.payment_status) ? this.options.payment_status = false: this.options.payment_status = true;
            }
        },
        clearFilter(key) {
            if (key == 'typeOrder') {
                this.dataFilter.type = [];
            } else if (key == 'statusOrder') {
                this.dataFilter.status = [];
            } else if (key == 'payment_status') {
                this.dataFilter.payment_status = [];
            } else if (key == 'all') {
                this.dataFilter = initialFilter();
            }
        },
        filterChange() {
        },
        doneFilter() {
          let paymentCount = this.dataFilter.payment_status.length > 0 ? 1 : 0;
          this.$parent.countFilter = paymentCount;
          this.$parent.filterinfo(this.dataFilter);
        },
        myChangeEvent(val){
            // console.log(val);
        },
        mySelectEvent({id, text , color, name}){
            // console.log({id, text, color, name});
        },

    }
}

function initialFilter() {
    return {
      payment_status: [],
    }
}

</script>

<style>
  .suggest-item.hover  #salesStaff .text-danger {
    color: black !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/SalesOrder/FiltersMore.vue